import List from "./List";
import Show from "./Show";
import Edit from "./Edit";

export const ContactList = List;
export const ContactShow = Show;
export const ContactEdit = Edit;
